import formatDate from './formatDate'

export {
  formatDate,
}

export default function (Vue) {
  Vue.filter('formatDate', formatDate)
}